// extracted by mini-css-extract-plugin
export default {"remove_button":"styled_remove_button__VxVmA"};